"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _close = _interopRequireDefault(require("../../assets/img/close.svg"));
var _heartRegular = _interopRequireDefault(require("../../assets/img/heart-regular.svg"));
var _heartSolid = _interopRequireDefault(require("../../assets/img/heart-solid.svg"));
var _paperPlaneRegular = _interopRequireDefault(require("../../assets/img/paper-plane-regular.svg"));
require("./Lightbox.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Lightbox = function Lightbox(_ref) {
  var imageSrc = _ref.imageSrc,
    title = _ref.title,
    descriptions = _ref.descriptions,
    backdropColor = _ref.backdropColor,
    _ref$showLikeButton = _ref.showLikeButton,
    showLikeButton = _ref$showLikeButton === void 0 ? false : _ref$showLikeButton,
    _ref$showCommentButto = _ref.showCommentButton,
    showCommentButton = _ref$showCommentButto === void 0 ? false : _ref$showCommentButto,
    _ref$onLike = _ref.onLike,
    onLike = _ref$onLike === void 0 ? function () {} : _ref$onLike,
    _ref$onComment = _ref.onComment,
    onComment = _ref$onComment === void 0 ? function () {} : _ref$onComment,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    liked = _useState2[0],
    setLiked = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showComments = _useState4[0],
    setShowComments = _useState4[1];
  var handleLike = function handleLike() {
    setLiked(!liked);
    onLike();
  };
  var handleToggleComments = function handleToggleComments() {
    setShowComments(!showComments);
  };
  var handleCommentClick = function handleCommentClick() {
    onComment();
  };
  var backdropClass = "lightbox-backdrop-".concat(backdropColor);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-backdrop ".concat(backdropClass)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "lightbox-close",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _close["default"],
    alt: "Close"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: imageSrc,
    alt: "Lightbox",
    className: "lightbox-image"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-content"
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-title"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, title), /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-descriptions ".concat(showComments ? "show" : "")
  }, descriptions.map(function (desc, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "description-container"
    }, desc.src && /*#__PURE__*/_react["default"].createElement("img", {
      src: desc.src,
      alt: "",
      className: "profile-pic"
    }), /*#__PURE__*/_react["default"].createElement("p", null, desc.text));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-actions"
  }, showCommentButton && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleToggleComments,
    className: "show-comments-button"
  }, showComments ? "Hide Comments" : "Show Comments"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lightbox-actions"
  }, showLikeButton && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleLike,
    className: "like-button ".concat(liked ? "liked" : "")
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: liked ? _heartSolid["default"] : _heartRegular["default"],
    alt: "Like"
  })), showCommentButton && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleCommentClick,
    className: "comment-button"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _paperPlaneRegular["default"],
    alt: "Comment"
  })))))));
};
var _default = exports["default"] = Lightbox;